import Combobox, { LabelPosition, Size } from "@ls/react-combobox-grid";
import PropTypes from "prop-types";
import React, { memo, useMemo } from "react";
import { useSelector } from "react-redux";
import { calcTypeOptions } from "state/Constants/CalcType";
import { Scan2PercentilesOptions } from "state/Constants/ScaleType";
//import {selectCovarianceOptions} from 'state/selections/selectors';
import { selectScan2CalcTypeOptions } from "state/scan2/selectors";
import { Cell, Grid } from "styled-css-grid";

const Scan2Complication = ({ setDefinition, definition }) => {
  const scan2CalcTypeOptions = useSelector(selectScan2CalcTypeOptions);

  const [setScan2CalcType, setPercentiles, setCalcType] = useMemo(() => {
    return [
      (value) => setDefinition(definition.setScan2CalcType(value)),
      (value) => setDefinition(definition.setPercentiles(value)),
      (value) => setDefinition(definition.setCalcType(value)),
    ];
  }, [definition, setDefinition]);

  return (
    <Grid columns={3} gap="4px">
      <Cell width={1}>
        <Combobox
          label="Calc Type:"
          onChange={setScan2CalcType}
          options={scan2CalcTypeOptions}
          labelPosition={LabelPosition.TOP}
          value={definition.scan2CalcType}
          placeholder="Calc Type..."
          gridHeight={100}
          size={Size.S}
          variation={0}
        />
      </Cell>
      <Cell width={1}>
        <Combobox
          label="Percentiles:"
          onChange={setPercentiles}
          options={Scan2PercentilesOptions}
          labelPosition={LabelPosition.TOP}
          value={definition.percentiles}
          placeholder="Percentiles..."
          gridHeight={100}
          size={Size.S}
          variation={0}
        />
      </Cell>
      {/*<Cell width={1}>*/}
      {/*  <Combobox*/}
      {/*    options={scaleTypeOptions}*/}
      {/*    onChange={setScaleType}*/}
      {/*    value={definition.scaleType}*/}
      {/*    label="Type:"*/}
      {/*    placeholder="Types..."*/}
      {/*    clearable={false}*/}
      {/*    variation={0}*/}
      {/*    size={'S'}*/}
      {/*    gridHeight={120}*/}
      {/*  />*/}
      {/*</Cell>*/}
      <Cell width={1}>
        <Combobox
          options={calcTypeOptions}
          onChange={setCalcType}
          value={definition.calcType}
          label="Calc:"
          clearable={false}
          variation={0}
          size={"S"}
          gridHeight={120}
        />
      </Cell>
    </Grid>
  );
};

Scan2Complication.propTypes = {
  setDefinition: PropTypes.func.isRequired,
  definition: PropTypes.object.isRequired,
};

export default memo(Scan2Complication);
